import React, { useState } from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import TableRowsIcon from '@mui/icons-material/TableRows';
import Fp1OrdersBoard from './Fp1OrdersBoard';
import Fp1OrdersList from './Fp1OrdersList';

type OrdersViewMode = 'board' | 'table';

/**
 * Wrapper for the FP1 "Orders" subtab. Adds a Board / Table view toggle so the
 * new 3-column kanban board is available *alongside* the existing full-featured
 * orders table (search filters, create order, live view, per-order edit). The
 * board is the default at-a-glance view for spotting stuck orders; the table is
 * unchanged and retains every existing action.
 */
const Fp1OrdersSection: React.FC = () => {
    const [mode, setMode] = useState<OrdersViewMode>('board');

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 1,
                    px: 2,
                    pt: 2,
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Marketplace Orders (FP1)
                </Typography>
                <ToggleButtonGroup
                    size="small"
                    exclusive
                    value={mode}
                    onChange={(_e, next: OrdersViewMode | null) => {
                        if (next) setMode(next);
                    }}
                >
                    <ToggleButton value="board">
                        <ViewKanbanIcon fontSize="small" sx={{ mr: 0.5 }} />
                        Board
                    </ToggleButton>
                    <ToggleButton value="table">
                        <TableRowsIcon fontSize="small" sx={{ mr: 0.5 }} />
                        Table
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>

            {mode === 'board' ? <Fp1OrdersBoard /> : <Fp1OrdersList />}
        </Box>
    );
};

export default Fp1OrdersSection;
